import { render, staticRenderFns } from "./thematicEditJg.vue?vue&type=template&id=0d488f1e&scoped=true"
import script from "./thematicEditJg.vue?vue&type=script&lang=js"
export * from "./thematicEditJg.vue?vue&type=script&lang=js"
import style0 from "./thematicEditJg.vue?vue&type=style&index=0&id=0d488f1e&prod&lang=less&scoped=true"
import style1 from "./thematicEditJg.vue?vue&type=style&index=1&id=0d488f1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d488f1e",
  null
  
)

export default component.exports